import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 17.333h24a1.334 1.334 0 0 0 0-2.666H4a1.334 1.334 0 0 0 0 2.666Zm0-8h24a1.334 1.334 0 0 0 0-2.666H4a1.334 1.334 0 0 0 0 2.666Zm0 16h24a1.334 1.334 0 0 0 0-2.666H4a1.334 1.334 0 0 0 0 2.666Z" }));
const ForwardRef = forwardRef(SvgMenu);
export default ForwardRef;
